import React from "react";
import type { BaseProps } from "@purpur/common-types";
import { Paragraph } from "@purpur/paragraph";
import c from "classnames/bind";

import styles from "./pagination-truncation-separator.module.scss";

const cx = c.bind(styles);

export type PaginationTruncationSeparatorProps = Omit<BaseProps<"li">, "children">;

const rootClassName = "purpur-pagination-truncation-separator";

export const PaginationTruncationSeparator = ({
  ["data-testid"]: dataTestId = "purpur-pagination-truncation-separator",
  className,
  ["aria-label"]: ariaLabel,
  ...props
}: PaginationTruncationSeparatorProps) => {
  const classes = cx(className, rootClassName);

  return (
    <li className={classes} data-testid={dataTestId} {...props}>
      <Paragraph aria-label={ariaLabel}>...</Paragraph>
    </li>
  );
};

PaginationTruncationSeparator.displayName = "PaginationTruncationSeparator";
